import { Code, ConnectError } from '@bufbuild/connect';
import { useEffect, useState } from 'react';

import { LoadingStateType } from '@/shared/config';

import { StaffRef, StaffRequest } from '../config';

export const useStaffSecurityStatus = <Status>(
  staff: StaffRef,
  readStatus: (request: StaffRequest) => Promise<Status>,
) => {
  const { userID, organizationID } = staff;

  const [status, setStatus] = useState<Status | null>(null);
  const [loadingState, setLoadingState] = useState<LoadingStateType>('idle');
  const [isDenied, setIsDenied] = useState(false);

  const request: StaffRequest = {
    UserID: userID,
    OrganizationID: organizationID,
  };

  const fetchStatus = async () => {
    setLoadingState('pending');

    try {
      const response = await readStatus(request);

      setStatus(response);
      setLoadingState('succeeded');
    } catch (error) {
      setIsDenied((error as ConnectError).code === Code.PermissionDenied);
      setLoadingState('failed');
    }
  };

  useEffect(() => {
    fetchStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userID, organizationID]);

  return { request, status, setStatus, loadingState, isDenied, fetchStatus };
};
